import React from "react";
import type { RouteObject } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { SurveyFormScreen } from "./pages/form/survey-form.screen";
import { MenuScreen } from "./pages/menu";
import { PendingFollowUpScreen } from "./pages/pending-follow-up";
import { CandidateDataFormScreen } from "./pages/candidate-data-form/candidate-data-form.screen";
import { JoinDoneScreen } from "./pages/candidate-data-form/join-done.screen";
import { JoinExpiredScreen } from "./pages/candidate-data-form/join-expired.screen";
import { InvitationCancelledScreen } from "./pages/candidate-data-form/invitation-cancelled.screen";
import { CourseMenuScreen } from "./pages/course-menu-screen/course-menu-screen";
import { CourseLessonScreen } from "./pages/course-menu-screen/screens/course-lesson-screen/course-lesson-screen";
import { CourseQuizScreen } from "./pages/course-menu-screen/screens/course-quiz-screen/course-quiz-screen";
import { ExamMenuScreen } from "./pages/exam-menu-screen/exam-menu-screen";
import { CourseQuizFeedbackScreen } from "./pages/course-menu-screen/screens/course-quiz-screen/quiz-feedback-screen";
import { ExamFeedbackScreen } from "./pages/exam-menu-screen/screens/exam-registry-screen/exam-feedback-screen";
import { ReassessPage } from "./pages/reassess/reassess.screen";
import { ApplicationDetailScreen } from "./pages/application-detail-screen/application-detail.screen";
import { TrainingPaymentScreen } from "./pages/training-payment-screen/training-payment-screen";
import { DocumentDownloadScreen } from "./pages/document-download-screen/document-download-screen";
import { ExamRegistryPaymentScreen } from "./pages/exam-menu-screen/screens/exam-registry-screen/exam-registry-payment-screen";
import { CandidateHomeScreen } from "./pages/candidate-home/candidate-home.screen";
import { SettingScreen } from "./pages/setting/setting.screen";
import { OtpVerificationScreen } from "./pages/otp-verification-screen/otp-verification.screen";
import { SetPasswordScreen } from "./pages/set-password-screen/set-password.screen";
import IdleTimerLayout from "../common/idle-timer/idle-timer-layout";
import { ProtocolScreenPage } from "./pages/protocol-screen/protocol-screen.screen";
import { PrivacyNoticeScreen } from "./pages/protocol-screen/privacy-notice.screen";
import { InboxListScreen } from "./pages/inbox/inbox-list-screen/inbox-list-screen";
import { InboxSearchScreen } from "./pages/inbox/inbox-search-screen/inbox-search-screen";
//PHKL Custom -s
import { EditInfoScreen } from "./pages/phkl/edit-info/edit-info.screen";
import { ForgetPasswordScreen } from "./pages/phkl/forget-password/forget-password.screen";
//PHKL Custom -e
import { LoginScreen } from "./pages/login/login.screen";
import { SSOCallbackScreen } from "./pages/sso-callback/sso-callback-screen";
import { PrudnaHistoryPage } from "./pages/prudna-history/prudna-history.screen";

export const routesOnboarding: RouteObject[] = [
  {
    path: "login",
    element: <LoginScreen />,
    gaData: {
      module: "Login",
      feature: "Login",
      journey: "general_login",
      stage: "feature_entry",
      screen_name: "Login-Screen",
    },
  },
  {
    path: "sso-callback",
    element: <SSOCallbackScreen />,
    gaData: {
      module: "Login",
      feature: "Login",
      journey: "sso_login",
      stage: "feature_entry",
      screen_name: "SSO-Login-Screen",
    },
  },
  { path: "menu", index: true, element: <MenuScreen /> },
  { path: "form", element: <SurveyFormScreen /> },
  { path: "application-detail", element: <ApplicationDetailScreen /> },
  {
    path: "courses",
    element: <Outlet />,
    children: [
      { path: "", index: true, element: <CourseMenuScreen /> },
      { path: "payment", element: <TrainingPaymentScreen /> },
      { path: "lesson", element: <CourseLessonScreen /> },
      { path: "quiz/:quizId", element: <CourseQuizScreen /> },
      { path: "quiz/:quizId/feedback", element: <CourseQuizFeedbackScreen /> },
    ],
  },
  {
    path: "exams",
    element: (
      <IdleTimerLayout>
        <Outlet />
      </IdleTimerLayout>
    ),
    children: [
      { path: "", index: true, element: <ExamMenuScreen /> },
      // { path: "registry/:examId", element: <ExamRegistryScreen /> },
      { path: "registry/:examId/feedback", element: <ExamFeedbackScreen /> },
      { path: "registry/:examId", element: <ExamRegistryPaymentScreen /> },
    ],
  },
  // { path: "courses", element: <CourseMenuScreen /> },
  { path: "follow-up", element: <PendingFollowUpScreen /> },
  { path: "reassess", element: <ReassessPage /> },
  //PHKL Custom -s
  {
    path: "edit-info",
    element: <EditInfoScreen />,
    gaData: {
      module: "Recruitment",
      feature: "CandidateProfile",
      journey: "view_profile",
      stage: "view_profile",
      screen_name: "Recruitment-Candidate-Profile-Screen",
    },
  },
  { path: "forget-password", element: <ForgetPasswordScreen /> },
  //PHKL Custom -e
  {
    path: "join-now",
    element: <CandidateDataFormScreen />,
    gaData: {
      module: "Recruitment",
      feature: "CandidateProfile",
      journey: "view_profile",
      stage: "view_profile",
      screen_name: "Recruitment-Candidate-Profile-Screen",
    },
  },
  { path: "join-done", element: <JoinDoneScreen /> },
  { path: "join-expired", element: <JoinExpiredScreen /> },
  { path: "invitation-cancelled", element: <InvitationCancelledScreen /> },
  { path: "document-download", element: <DocumentDownloadScreen /> },
  {
    path: "candidate-home",
    element: (
      <IdleTimerLayout>
        <CandidateHomeScreen />
      </IdleTimerLayout>
    ),
    gaData: {
      module: "Recruitment",
      feature: "CandidateProfile",
      journey: "view_profile",
      stage: "view_profile",
      screen_name: "Recruitment-Candidate-Profile-Screen",
    },
  },

  {
    path: "setting",
    element: (
      <>
        <SettingScreen />
      </>
    ),
  },
  {
    path: "otp-verification",
    index: true,
    element: <OtpVerificationScreen />,
    gaData: {
      module: "Login",
      feature: "CandidateLogin",
      journey: "create_account",
      stage: "feature_entry",
      screen_name: "Login-Candidate-Create-Account-Screen",
    },
  },
  {
    path: "set-password",
    index: true,
    element: <SetPasswordScreen />,
    gaData: {
      module: "Login",
      feature: "CandidateLogin",
      journey: "create_account",
      stage: "set_password",
      screen_name: "Login-Candidate-Set-Password-Screen",
    },
  },
  { path: "protocol", index: true, element: <ProtocolScreenPage /> },
  {
    path: "privacy-notice",
    index: true,
    element: <PrivacyNoticeScreen />,
  },
  {
    path: "inbox",
    element: <Outlet />,
    children: [
      {
        path: "",
        index: true,
        element: (
          <IdleTimerLayout>
            <InboxListScreen />
          </IdleTimerLayout>
        ),
      },
      {
        path: "search",
        element: (
          <IdleTimerLayout>
            <InboxSearchScreen />
          </IdleTimerLayout>
        ),
      },
    ],
  },
  {
    path: "prudna-history",
    element: (
      <IdleTimerLayout>
        <PrudnaHistoryPage />
      </IdleTimerLayout>
    ),
  },
];
